import { render, staticRenderFns } from "./ForumManagement.vue?vue&type=template&id=27c79c24&scoped=true&"
import script from "./ForumManagement.vue?vue&type=script&lang=js&"
export * from "./ForumManagement.vue?vue&type=script&lang=js&"
import style0 from "./ForumManagement.vue?vue&type=style&index=0&id=27c79c24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c79c24",
  null
  
)

export default component.exports